// Brand colors and typography configuration
export const theme = {
  colors: {
    primary: '#812118',        // Deep cherry - main background
    secondary: '#ffdaec',      // Blush pink - panels
    accent: '#c9ae75',         // Gold - accents
    cream: '#f6efe5',          // Cream - alternate panels
    white: '#ffffff',
    text: {
      dark: '#1a1918',
      light: '#ffffff',
      subtle: '#736c64',
    },
  },
  fonts: {
    heading: '"Playfair Display", serif',  // Editorial serif
    body: '"Inter", -apple-system, sans-serif',
  },
  spacing: {
    section: '80px',
    sectionMobile: '48px',
  },
};

export default theme;
